import mongoid from 'mongoid-js';
import { createSelector } from 'reselect';
import {
  LABELS_ADD_ROW,
  LABELS_DELETE_ROW,
  LABELS_UPDATE_ROW,
  LABELS_COPY_ROW,
  LABELS_DELETE_ALL,
  LABELS_PRINT_ALL,
  LABELS_FINISHED_PRINTING,
  LABELS_SET_PAGE
} from './constants';

const initialState = {
  labels: {},
  printing: false,
  page: 1,
  pageSize: 20
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LABELS_ADD_ROW: {
      const labels = JSON.parse(JSON.stringify(state.labels));
      labels[action.label.id] = action.label;
      const page = Math.ceil(Object.keys(labels).length / state.pageSize);
      return { ...state, labels, page };
    }
    case LABELS_DELETE_ROW: {
      const labels = JSON.parse(JSON.stringify(state.labels));
      delete labels[action.labelId];
      return { ...state, labels };
    }
    case LABELS_UPDATE_ROW: {
      const labels = JSON.parse(JSON.stringify(state.labels));
      labels[action.label.id] = action.label;
      return { ...state, labels };
    }
    case LABELS_COPY_ROW: {
      const labels = JSON.parse(JSON.stringify(state.labels));
      const label = { ...action.label };
      label.id = mongoid();
      labels[label.id] = label;
      return { ...state, labels };
    }
    case LABELS_DELETE_ALL: {
      return { ...state, labels: {} };
    }
    case LABELS_PRINT_ALL: {
      return { ...state, printing: true };
    }
    case LABELS_FINISHED_PRINTING: {
      return { ...state, printing: false };
    }
    case LABELS_SET_PAGE:
      return { ...state, page: action.page };
  }
  return state;
};

const labelsObj = state => state.labels.labels;
const printing = state => state.labels.printing;
const page = state => state.labels.page;
const pageSize = state => state.labels.pageSize;

export const getLabels = createSelector(
  labelsObj, labels => {
    return Object.values(labels);
  }
);

export const getPageOfLabels = createSelector(
  [getLabels, page, pageSize], (labels, page, size) => {
    return labels.slice(size * (page - 1), size * page);
  }
);

export const getLabelPage = createSelector(
  page, page => page
);

export const getLabelPageSize = createSelector(
  pageSize, size => size
);

export const getLabelPageCount = createSelector(
  [getLabels, pageSize], (labels, size) => Math.ceil(labels.length / size)
);

export const isPrinting = createSelector(printing, printing => printing);

export default reducer;
